<template>
  <DialogWrapper
    class="apply-success-dialog"
    :show.sync="resumeApplySuccessDialogShow"
    :close-on-click-modal="false"
    :showClose="false"
    :hideFooter="true"
  >
    <div class="content" :style="customStyle">
      <div v-if="loading" class="applying">
        <div v-rect-loading="loading" class="applying-loading"></div>
        <div class="applying-label">{{ $t(`${i18nPrefix}.label.applying`) }}</div>
      </div>
      <div v-else>
        <i class="success-icon iconfont iconcompleted"></i>
        <template v-if="!assessment && !resumeApplyData.has_applied">
          <div class="title-label">{{ $t(`${i18nPrefix}.label.applySuccess`) }}</div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.successDescription`, {title: resumeApplyData.job?.i18nTitle, company: resumeApplyData.company?.i18nName}) }}</div>
          <div
            v-if="resumeApplyData.invitation_url"
            v-html="$t(`${i18nPrefix}.label.invitationUrl`, {invitationUrl: resumeApplyData.invitation_url})"
            class="title-description"
          >
          </div>
          <div v-if="resumeApplyData.we_app_qrcode_base64" class="coach-ai-interview-qrcode">
              <div class="coach-title">{{ $t(`${i18nPrefix}.label.coachAI`) }}</div>
              <img class='qr-code' :src="`data:image/jpeg;base64,${ resumeApplyData.we_app_qrcode_base64 }`"/>
          </div>
          <div v-if="resumeApplyData.qrcode_url" class="qr-block">
            <span class='qr-msg'>{{ $t(`${i18nPrefix}.label.followUs`) }}</span>
            <img class='qr-code' :src="resumeApplyData.qrcode_url"/>
          </div>
          <div v-if="resumeApplyData.job?.ats_job_id && appliedJobCompanyId === 13529" class="title-description">
            {{ $t(`${i18nPrefix}.label.onRunningEightfoldTip`) }}
          </div>
          <div class="btn-group">
            <el-button class="button to-personal-home" type="primary" @click="handleToHome(false)">{{ $t(`${i18nPrefix}.btn.homePage`) }}</el-button>
            <el-button v-if="resumeApplyData.candidate_finished_assessment" class="button to-view-reports" type="primary" @click="handleViewReport">{{ $t(`${i18nPrefix}.btn.viewReport`) }}</el-button>
          </div>
        </template>
        <template v-else-if="assessment">
          <div class="title-label">{{ $t(`${i18nPrefix}.label.thankApply`) }}</div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.assessmentDescription`) }}</div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.assessmentDescriptionTip`) }}</div>
          <div class="title-description"><a :href="mixedRouterPush(`/invite-candidate-finish-apply/?jobId=${resumeApplyData.job?.id}`)">{{ $t(`${i18nPrefix}.label.doAssessment`) }}</a></div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.moreInfo`) }}</div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.seeAllJobs`) }}</div>
          <div class="btn-group">
            <el-button class="button to-personal-home" type="primary" @click="handleToHome(false)">{{ $t(`${i18nPrefix}.btn.homePage`) }}</el-button>
            <el-button v-if="resumeApplyData.candidate_finished_assessment" class="button to-view-reports" type="primary" @click="handleViewReport">{{ $t(`${i18nPrefix}.btn.viewReport`) }}</el-button>
          </div>
        </template>
        <template v-else>
          <div class="title-label">{{ $t(`${i18nPrefix}.label.alreadyApplied`) }}</div>
          <div class="title-description">{{ $t(`${i18nPrefix}.label.appliedDescription`) }}</div>
          <div v-if="resumeApplyData.we_app_qrcode_base64" class="coach-ai-interview-qrcode">
              <div class="coach-title">{{ $t(`${i18nPrefix}.label.coachAI`) }}</div>
              <img class='qrcode' :src="`data:image/jpeg;base64,${ resumeApplyData.we_app_qrcode_base64 }`"/>
          </div>
          <div class="btn-group">
              <el-button class="button to-personal-home" type="primary" @click="handleToHome(false)">{{ $t(`${i18nPrefix}.btn.homePage`) }}</el-button>
              <el-button class="button to-job-list" type="primary" @click="handleContinueApply">{{ $t(`${i18nPrefix}.btn.jobList`) }}</el-button>
          </div>
        </template>
      </div>
    </div>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'
import { addI18nProperty } from '@/i18n'
import { mixedRouterPush } from '@/router/routes'

export default {
  components: {
    DialogWrapper
  },
  props: {
    resumeApplySuccessDialogShow: {
      type: Boolean,
      default: false
    },
    resumeApplyData: {
      type: Object,
      default: () => ({})
    },
    jobId: {
      require: true
    },
    assessment: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mixedRouterPush,
      i18nPrefix: 'personal.resume'
    }
  },
  computed: {
    appliedJobCompanyId () {
      return this.resumeApplyData.company?.id
    },
    customStyle () {
      return {
        '--custom-color': this.resumeApplyData.company?.root_company_id === ROOT_COMPANY_ID.MERCEDES_BENZ ? '#000' : null
      }
    }
  },
  methods: {
    handleToHome (homePage) {
      this.$router.replace({ path: '/recruiting/personal/home', query: { company_id: this.appliedJobCompanyId } })
    },
    handleViewReport () {
      this.$router.replace({ path: '/recruiting/personal/report', query: { company_id: this.appliedJobCompanyId } })
    },
    handleContinueApply () {
      this.$router.replace(`/recruiting/company/${this.appliedJobCompanyId}/job-list`)
    }
  },
  watch: {
    resumeApplyData: {
      immediate: true,
      handler () {
        if (this.resumeApplyData.job) {
          addI18nProperty(this.resumeApplyData.job, 'i18nTitle', 'cn_title', 'title')
        }
        if (this.resumeApplyData.company) {
          addI18nProperty(this.resumeApplyData.company, 'i18nName', 'cn_name', 'name')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.apply-success-dialog {

  .content {
    padding: 0 25px 0 25px;
    text-align: center;

    .applying {
      .applying-loading {
        width: 100%;
        height: 150px;
      }

      .applying-label {
        font-size: 16px;
        color: #303133;
        line-height: 30px;
        margin-bottom: 20px;
      }
    }

    .domain {
      position: absolute;
      right: 25px;
      top: 30px;

      .company-logo {
        height: 50px;
      }
    }

    .success-icon {
      font-size: 50px;
      color: #52C41A;
    }

    .title-label {
      font-weight: 500;
      font-size: 22px;
      color: #303133;
      line-height: 30px;
      margin: 15px 0;
      word-break: break-word;
      white-space: pre-wrap;
    }

    .title-description {
      font-weight: 400;
      font-size: 16px;
      color: #606266;
      line-height: 22px;
      margin: 5px 0;
      word-break: break-word;
      white-space: pre-wrap;
    }

    .coach-ai-interview-qrcode {
      margin-top: 30px;
      font-size: 14px;
      color: #666;
      text-align: center;

      .coach-title {
        word-break: break-word;
        white-space: pre-wrap;
      }

      .qr-code {
        margin-top: 10px;
        width: 150px;
        height: 150px;
      }
    }

    .btn-group {
      margin: 20px 0;
      display: flex;
      align-items: center;
      flex-direction: column;

      .button {
        width: 260px;
        height: 40px;
        margin: 5px 0;
        color: #fff;
        background-color: var(--custom-color, #0096cc);
        border-color: var(--custom-color, #0096cc);
      }
    }

  }
}
</style>
